const STUDIOS_REQUIRING_TEAM_NAMES = ['bnlschoolpictures'];

export default STUDIOS_REQUIRING_TEAM_NAMES;
